import React from 'react';

import styles from '../PortfolioAnalytics.module.scss';
import { Form } from '../../../shared/icons';
import { ConfirmationModal } from '../../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../../shared/modal/ModalHeader';
import { Text } from '../../../shared/text/Text';

interface PortfolioAnalyticsSaveTemplateModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    confirm: () => void;
    confirmDisabled: boolean;
    confirmDisabledTooltip: string[];
    updateTemplateName: (value: string) => void;
    templateName: string;
}

export const PortfolioAnalyticsSaveTemplateModal: React.FC<PortfolioAnalyticsSaveTemplateModalProps> = ({ modalOpen, closeModal, confirm, confirmDisabled, confirmDisabledTooltip, updateTemplateName, templateName }) => (
    <ConfirmationModal
        isOpen={modalOpen}
        closeModal={closeModal}
        confirmLabel='Save Template'
        confirm={confirm}
        confirmDisabled={confirmDisabled}
        spaceBetweenButtons={true}
        confirmDisabledTooltip={confirmDisabledTooltip}
    >
        <div className={styles.saveTemplateModalWrapper}>
            <ModalHeader
                testId='portfolio-analytics-save-template-modal'
                label='Template Name'
                icon={Form}
            />
            <div className={styles.templateNameWrapper}>
                <Text
                    onChange={e => updateTemplateName(e.currentTarget.value)}
                    value={templateName}
                    testId='portfolio-analytics-template-name'
                    placeholder={templateName}
                    marginBottom='0px'
                    maxLength={200}
                />
            </div>
        </div>
    </ConfirmationModal>
);
